export default {
    title: 'Saplings',
    'placeholder': 'Mudas',
 
   
 
  };